import api from '../../services/api';

export const getGoogleRecaptchaValidation = async (validationRequest) => {
    return await api.post(`/api/GoogleRecaptcha`, validationRequest, {
        headers: {
            Accept: "application/json",
        },
    })
}
